(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("dk3v6", function(module, exports) {

var $kWqGi = parcelRequire("kWqGi");
const $9b2fdbc6e52339c0$var$responseSettings = {
    method: "GET"
};
const $9b2fdbc6e52339c0$var$SEARCH_ENDPOINT = "/wp-json/jip/v1/search-suggest";
const $9b2fdbc6e52339c0$var$headerSearches = document.querySelectorAll(".m-header-search");
const $9b2fdbc6e52339c0$var$mainOverlay = document.querySelector(".c-overlay-main");
const $9b2fdbc6e52339c0$var$openers = document.querySelectorAll(".--js--main-search-opener");
const $9b2fdbc6e52339c0$var$closers = document.querySelectorAll(".--js-main-search-closer");
$9b2fdbc6e52339c0$var$headerSearches.forEach((headerSearch)=>{
    let filterAbortController = null;
    const input = headerSearch.querySelector("input.f-text__input");
    const dropdown = headerSearch.querySelector(".m-header-search__dropdown");
    const dropdownList = dropdown?.querySelector(".m-header-search__dropdown-list");
    const open = ()=>{
        headerSearch.classList.add("--open");
        $9b2fdbc6e52339c0$var$mainOverlay?.classList.add("--show");
        input?.focus();
    };
    const close = ()=>{
        headerSearch.classList.remove("--open");
        $9b2fdbc6e52339c0$var$mainOverlay?.classList.remove("--show");
        input?.blur();
    };
    $9b2fdbc6e52339c0$var$openers.forEach((opener)=>opener.addEventListener("click", open));
    $9b2fdbc6e52339c0$var$closers.forEach((closer)=>closer.addEventListener("click", close));
    if (!input) return;
    const fetchSearch = async ()=>{
        if (filterAbortController) filterAbortController.abort();
        filterAbortController = new AbortController();
        const { signal: signal } = filterAbortController;
        dropdown?.classList.add("--loading");
        let removeLoading = true;
        try {
            const searchParam = input.value ? `?s=${input.value}` : "";
            const url = `${$9b2fdbc6e52339c0$var$SEARCH_ENDPOINT}${searchParam}`;
            const response = await fetch(url, {
                ...$9b2fdbc6e52339c0$var$responseSettings,
                signal: signal
            });
            const data = await response.json();
            if (data.html && dropdownList) dropdownList.innerHTML = data.html;
        } catch (error) {
            if (error instanceof Error && error.name === "AbortError") {
                console.log("Previous fetch aborted.");
                removeLoading = false;
            } else console.error("Error:", error);
        } finally{
            if (removeLoading) dropdown?.classList.remove("--loading");
        }
    };
    input.addEventListener("input", (0, $kWqGi.debounce)(fetchSearch, 500));
});

});
parcelRegister("kWqGi", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $f3edebc483f39217$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "hashCode", function () { return $f3edebc483f39217$export$d41d9ab3de2def3d; });
function $f3edebc483f39217$export$6d4016d301bc6e21(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (e) {
        console.log("Error occurred while validating query:", e);
    }
    return false;
}
function $f3edebc483f39217$export$d70cf44bc3ae170(type, selector, callback, parent = document) {
    parent.addEventListener(type, (event)=>{
        const target = event.target;
        if (target instanceof Element && target.closest(selector)) {
            const clickedElement = target.closest(selector);
            if (clickedElement) callback(clickedElement, event);
        }
    });
}
const $f3edebc483f39217$export$61fc7d43ac8f84b0 = (fn, delay = 500)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            fn.apply(undefined, args);
        }, delay);
    };
};
function $f3edebc483f39217$export$d41d9ab3de2def3d(str) {
    return str.split("").reduce((prevHash, currVal)=>(prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0, 0);
}

});


})();
//# sourceMappingURL=main-header-search.8bd7bb3f.js.map
